
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airdrops",
      function () {
        return require("private-next-pages/airdrops/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airdrops"])
      });
    }
  